import { render, staticRenderFns } from "./ApplicationQuestions.vue?vue&type=template&id=10d5cd80&scoped=true&"
import script from "./ApplicationQuestions.vue?vue&type=script&lang=js&"
export * from "./ApplicationQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationQuestions.vue?vue&type=style&index=0&id=10d5cd80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5cd80",
  null
  
)

export default component.exports